import { useCallback, useEffect, useMemo, useState } from 'react'
import useApi from './useApi'
import PATHS from 'constants/paths'
import { TSelectOption } from 'types'

interface IBankFromApi {
  id: string
  nome: string
  numero: string
}

interface IUseBankReturn {
  bankOptions: TSelectOption[]
  bankValuesSet: Set<string>
}

export function useBank(cnpj?: string): IUseBankReturn {
  const [bankOptions, setBankOptions] = useState<TSelectOption[]>([])

  const bankValuesSet = useMemo(() => {
    return new Set(bankOptions.map((option) => option.value))
  }, [bankOptions])

  const { apiRequest } = useApi()

  const getBanks = useCallback(async () => {
    const response = await apiRequest({
      path: PATHS.BANKS,
      method: 'GET',
      queryParams: {
        limit: 999,
        fields: 'id,numero,nome',
        cnpj,
      },
    })

    if (response && response.results) {
      const banksFromApi = response.results.map(
        (bank: IBankFromApi): TSelectOption => ({
          value: bank.numero,
          label: `${bank.numero} - ${bank.nome}`,
        })
      )

      setBankOptions(banksFromApi)
    }
  }, [apiRequest, cnpj])

  useEffect(() => {
    getBanks()
  }, [getBanks])

  return {
    bankOptions,
    bankValuesSet,
  }
}

export default useBank
